import { stackGrafanaPlugin } from './plugin';

export default stackGrafanaPlugin;
